/**
 * Created by Jie Gao on 05/24/2019.
 */

import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {ReelSymbolName} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GGGameAssets} from "../GGGameAssets";

export class GGReelSymbolStateCreator extends ReelSymbolStateCreator {

    constructor() {
        super();
    }

    public createStateAnimation(symbol:StateReelSymbol, stateConfig:ISymbolStateConfig):TimelineSprite | null {
        if(symbol.symName === ReelSymbolName.EMPTY) {
            return null;
        }

        return super.createStateAnimation(symbol, stateConfig);
    }

    public createSpinStateAnimation(symbol:StateReelSymbol, stateConfig:ISymbolStateConfig):TimelineSprite | null {
       return null;
    }

    protected getBasicStateAnimation(symbol:StateReelSymbol, stateKey:string, stateConfig:ISymbolStateConfig):TimelineSprite | null {
        if(stateConfig.symbols && stateConfig.symbols.indexOf(symbol.stackedSymName!.symName) === -1) {
            return null;
        }

        if(!stateConfig.texturesCreator) {
            stateConfig.texturesCreator = (symName:string, stateKey:string):PIXI.Texture[] => ReelSymbolStateCreator.defaultSymbolStateTexturesCreator(symName, stateKey);
        }

        let textures = stateConfig.texturesCreator(symbol.stackedSymName!.symName, stateKey);
        if(symbol.symName[0] === "M"){
           textures = GGGameAssets.getSymbolMStateTextures(`${symbol.stackedSymName!.symName}_${Math.floor(544 / symbol.symHeight)}`);
        }

        if(textures == null || textures.length === 0) {
            return null;
        }

        const fps:number = stateConfig.fpsGetter ? stateConfig.fpsGetter(symbol.stackedSymName!.symName, stateKey) : GameConfig.instance.BROWSER_FPS;
        const sprite:TimelineSprite = new TimelineSprite(textures, fps);
        sprite.name = symbol.stackedSymName!.symName + stateKey;

        StateReelSymbol.setStackedSymbolStateAnchor(symbol, sprite);

        if(stateConfig.offsetGetter) {
            const offset:[number, number] = stateConfig.offsetGetter(symbol.stackedSymName!.symName, stateKey);
            sprite.position.set(offset[0], offset[1]);
        }
        return sprite;
    }
}